import styled from 'styled-components';

import { Link } from '@xing-com/crate-components-link';
import { mediaSmallOrTiny } from '@xing-com/layout-tokens';
import { ListItem, List } from '@xing-com/list';
import { scale000, space4XL, spaceL, spaceXXL } from '@xing-com/tokens';

const StyledList = styled(List)`
  margin: ${spaceL} 0 calc(${space4XL} - ${spaceL}) !important;

  @media ${mediaSmallOrTiny} {
    margin-bottom: ${spaceXXL} !important;
  }

  @media (min-width: 1113px) {
    justify-content: space-between;
  }
`;

const StyledListItem = styled(ListItem)`
  font-weight: bold;
  padding: ${scale000} ${scale000} ${spaceL} !important;
`;

const StyledLink = styled(Link)`
  min-width: ${spaceXXL};
`;

export const Styled = {
  List: StyledList,
  ListItem: StyledListItem,
  Link: StyledLink,
};
